import {
  buildTranslationUrl,
  loadTranslationViaIDB,
  normalizeLanguage,
} from './i18nextIDBCache';

/**
 * Custom i18next backend — IndexedDB first, network only on cache miss.
 * Replaces i18next-http-backend so translation loads cannot bypass the cache.
 */
export const i18nextIDBBackend = {
  type: 'backend',

  init(_services, backendOptions = {}) {
    this.options = backendOptions;
  },

  read(language, namespace, callback) {
    const lng = normalizeLanguage(language);
    const url = buildTranslationUrl(lng, namespace);

    if (!url) {
      callback(new Error('I18NEXT_API_PATH is not configured'), null);
      return;
    }

    loadTranslationViaIDB({}, url)
      .then((data) => {
        try {
          callback(null, JSON.parse(data));
        } catch (parseErr) {
          callback(parseErr, null);
        }
      })
      .catch((err) => callback(err, null));
  },
};
